class MyProfileDetails {
  getMyProfileDetails() {
    return this.myProfileDetails;
  }

  setMyProfileDetails(myProfileDetails) {
    this.myProfileDetails = myProfileDetails;
  }

  resetMyProfileDetails() {
    this.myProfileDetails = null;

    //Member Details
    this.Title = '';
    this.FirstName = '';
    this.MiddleName = '';
    this.LastName = '';
    this.Suffix = '';
    this.DateOfBirth = '';
    this.Age = '';
    this.Gender = '';
    this.SocialSecNum = '';
    this.MaritalStatus = '';

    //Employment Details
    this.EmployerNameAndID = '';
    this.Department = '';
    this.BlockOfBusiness = '';
    this.Location = '';
    this.StartDate = '';

    //Phone & Email
    this.HomeOffice = '';
    this.WorkPhone = '';
    this.Email1 = '';
    this.Email2 = '';

    //Residential Address
    this.AddressLine1 = '';
    this.AddressLine2 = '';
    this.AddressLine3 = '';
    this.City = '';
    this.State = '';
    this.Zip = '';
    this.Country = '';

    //Mailing Address
    this.MailingAddressLine1 = '';
    this.MailingAddressLine2 = '';
    this.MailingAddressLine3 = '';
    this.MailingCity = '';
    this.MailingState = '';
    this.MailingZip = '';
    this.MailingCountry = '';

    //My Dependents
    this.myDependents = [];
  }
}
export default new MyProfileDetails();
